import { useEffect, useState } from 'react';
import api from '../api';

export function useYeniReferansSayisi(aktif: boolean = true) {
  const [sayi, setSayi] = useState(0);

  useEffect(() => {
    if (!aktif) return;
    const kontrol = () => {
      api.get('/api/referans/istatistik')
        .then(r => setSayi(Number(r.data.yeni) || 0))
        .catch(() => {});
    };
    kontrol();
    const interval = setInterval(kontrol, 60000);
    return () => clearInterval(interval);
  }, [aktif]);

  return sayi;
}
